<div class="step-content">
    <div class="step-header">
        <h2 class="step-title">Dental credentials</h2>
    </div>

    <form [formGroup]="dentistCredentialsForm">
        <div [ngClass]="{
            'custom-input-grid': documentsMap['STATE_LICENSE'].length,
            'form-grid no-file': !documentsMap['STATE_LICENSE'].length
        }">
            <!-- ================= STATE LICENSE ================= -->
            <div class="form-group">
                <app-file-text-upload label="State license" [required]="true" [hideLabel]="false"
                    [ngClass] ="stateLicenseCtrl.errors ? 'showAsterisk' : 'hideAsterisk'"
                    [control]="stateLicenseCtrl" [documents]="documentsMap['STATE_LICENSE']" docType="STATE_LICENSE"
                    (upload)="onUploadDocument($event)" (delete)="onDeleteDocument($event.type, $event.index)"
                    (view)="onViewDocument($event)" [errorMessages]="VALIDATION_MESSAGES['stateLicenseNumber']"
                    [buttonDisabled]="(documentsMap['STATE_LICENSE'] && documentsMap['STATE_LICENSE'].length ? true : false) || impersonatedUser"
                    [placeholder]="'Enter number & upload'" [maxLength]="FIELD_LIMITS['stateLicenseNumber']['maxLength']" toolTip="Upload Document" deleteToolTip="Delete Document">
                </app-file-text-upload>
            </div>
            <div class="form-group">
                <app-date-input label="Effective date" [placeholder]="'MM/DD/YYYY'" acceptedFormats="MM/DD/YYYY"
                    [control]="stateLicenseEffectiveDateCtrl" [maxDate]="maxStateLicenseEffectiveDate" 
                    [ngClass] ="stateLicenseEffectiveDateCtrl.errors ? 'showAsterisk' : 'hideAsterisk'"
                    [errorMessages]="VALIDATION_MESSAGES['stateLicenseEffectiveDate']"></app-date-input>
            </div>
        </div>

        <div class="custom-cds-grid">
            <!-- ================= CDS ================= -->
            <div class="form-group">
                <fieldset class="radio-fieldset"
                    [ngClass]="cdsForm.controls['cds'].errors ? 'showAsterisk' : 'hideAsterisk'">
                    <legend class="radio-legend">CDS license</legend>
                    <app-radio [formGroup]="cdsForm" [options]="cdsradioOptions" [layout]="'horizontal'"
                        [label]="''"></app-radio>
                </fieldset>
            </div>
        </div>

        @if (this.cdsForm.value.cds == 'true') {
        <div [ngClass]="{
            'custom-input-grid': documentsMap['CDS'].length,
            'form-grid no-file': !documentsMap['CDS'].length
        }">
            <!-- CDS LICENSE -->
            <div class="form-group state-licence-box">
                <app-file-text-upload label="CDS license" [required]="this.cdsForm.value.cds == 'true' ? true : false"
                    [hideLabel]="false" [control]="cdsLicenseCtrl" [documents]="documentsMap['CDS']" docType="CDS"
                    (upload)="onUploadDocument($event)" (delete)="onDeleteDocument($event.type, $event.index)"
                    (view)="onViewDocument($event)" [errorMessages]="VALIDATION_MESSAGES['cdsLicenseNumber']"
                    [buttonDisabled]="(documentsMap['CDS'] && documentsMap['CDS'].length ? true : false) || impersonatedUser"
                    [placeholder]="'Enter number & upload'" [maxLength]="FIELD_LIMITS['cdsLicenseNumber']['maxLength']"
                    [ngClass] ="cdsLicenseCtrl.errors ? 'showAsterisk' : 'hideAsterisk'" toolTip="Upload Document" deleteToolTip="Delete Document">
                </app-file-text-upload>
            </div>
            @if(this.cdsForm.value.cds == 'true') {
            <div class="form-group">
                <app-date-input label="Expiration date" [placeholder]="'MM/DD/YYYY'" acceptedFormats="MM/DD/YYYY"
                    [control]="cDSExpirationDateCtrl" [maxDate]="maxExpirationDate" 
                    [ngClass] ="cDSExpirationDateCtrl.errors ? 'showAsterisk' : 'hideAsterisk'"
                    [errorMessages]="VALIDATION_MESSAGES['cDSExpirationDate']"></app-date-input>
            </div>
            }
        </div>
        }

        <div class="custom-cds-grid">
            <!-- ================= DEA ================= -->
            <div class="form-group">
                <fieldset class="radio-fieldset"
                    [ngClass]="deaLicenseForm.controls['dea'].errors ? 'showAsterisk' : 'hideAsterisk'">
                    <legend class="radio-legend">DEA license</legend>
                    <app-radio [formGroup]="deaLicenseForm" [options]="dEALicenseradioOptions" [label]="''"
                        [layout]="'horizontal'"></app-radio>
                </fieldset>
            </div>
        </div>

        @if (this.deaLicenseForm.value.dea == 'true') {
        <div [ngClass]="{
            'custom-input-grid': documentsMap['DEA'].length,
            'form-grid no-file': !documentsMap['DEA'].length
        }">
            <!-- DEA LICENSE -->
            <div class="form-group">
                <app-file-text-upload label="DEA license"
                    [required]="this.deaLicenseForm.value.dea == 'true' ? true : false" [hideLabel]="false"
                    [control]="deaLicenseCtrl" [documents]="documentsMap['DEA']" docType="DEA"
                    (upload)="onUploadDocument($event)" (delete)="onDeleteDocument($event.type, $event.index)"
                    (view)="onViewDocument($event)" [errorMessages]="VALIDATION_MESSAGES['deaLicenseNumber']"
                    [buttonDisabled]="(documentsMap['DEA'] && documentsMap['DEA'].length ? true : false) || impersonatedUser"
                    [placeholder]="'Enter number & upload'" [maxLength]="FIELD_LIMITS['deaLicenseNumber']['maxLength']"
                    [ngClass] ="deaLicenseCtrl.errors ? 'showAsterisk' : 'hideAsterisk'" toolTip="Upload Document" deleteToolTip="Delete Document">
                </app-file-text-upload>
            </div>
            @if(this.deaLicenseForm.value.dea == 'true') {
            <div class="form-group">
                <app-date-input label="Expiration date" [placeholder]="'MM/DD/YYYY'" acceptedFormats="MM/DD/YYYY"
                    [control]="dEAExpirationDateCtrl" [maxDate]="maxExpirationDate" 
                    [ngClass] ="dEAExpirationDateCtrl.errors ? 'showAsterisk' : 'hideAsterisk'"
                    [errorMessages]="VALIDATION_MESSAGES['dEAExpirationDate']"></app-date-input>
            </div>
            }
        </div>
        }

        <div class="form-grid">
            <!-- ================= PAIN MANAGEMENT ================= -->
            <div class="form-group">
                <label class="formLabel">
                    @if(this.deaLicenseForm.value.dea == 'false' && this.cdsForm.value.cds == 'false') {
                    If no, explain how you manage pain for patients <span class="asteric" *ngIf="!painManagementCtrl.value">*</span>
                    } @else {
                    Explain how you manage pain for patients
                    }</label>
                <app-text-area id="note" [for]="'notes-Input'" [ngClass]="{ 'textarea-red': isNotesLimitExceeded() }"
                    class="remark-textarea remark-area-new dental-cred-text-field text-area-cred pain-management-textarea"
                    [fieldType]="'This field'" [replaceDoubelQuotes]="true" [control]="painManagementCtrl" [label]="(this.deaLicenseForm.value.dea == 'false' && this.cdsForm.value.cds == 'false') ? 
                    'if no, explain how you manage pain for patients' :  
                    'Explain how you manage pain for patients'" [hideLabel]="true"
                    [errorMessages]="VALIDATION_MESSAGES['painManagementNote']"
                    [maxLength]="FIELD_LIMITS['painManagementNote']['maxLength']">
                </app-text-area>
            </div>
        </div>

        <div class="custom-input-grid">
            <!-- ================= MALPRACTICE ================= -->
            <div class="form-group">
                <app-radio [formGroup]="policyTypeForm" [options]="policyTypeRadioOptions" [layout]="'horizontal'"
                    [ngClass] ="policyTypeForm.controls['malpracticePolicyType'].errors ? 'showAsterisk' : 'hideAsterisk'"
                    label="Policy type"></app-radio>
            </div>
        </div>

        <div class="form-grid">
            <!-- ================= CARRIER / POLICY ================= -->
            <div class="form-group">
                <app-text-input [label]="'Carrier name'" [hideLabel]="false" [maxLength]="80"
                    [control]="carrierNameCtrl" [maxLength]="FIELD_LIMITS['malpracticeCarrierName']['maxLength']"
                    [errorMessages]="VALIDATION_MESSAGES['malpracticeCarrierName']"
                    [ngClass] ="carrierNameCtrl.errors ? 'showAsterisk' : 'hideAsterisk'"></app-text-input>
            </div>
    
            <div class="form-group col-span-2">
                <app-file-text-upload [label]="'Policy number'" [required]="true" [hideLabel]="false"
                    [control]="policyHolderCtrl" [maxLength]="FIELD_LIMITS['malpracticePolicyHolder']['maxLength']"
                    [errorMessages]="VALIDATION_MESSAGES['malpracticePolicyHolder']"
                    [documents]="documentsMap['MALPRACTICE']" docType="MALPRACTICE"
                    (upload)="onUploadDocument($event)" (delete)="onDeleteDocument($event.type, $event.index)"
                    (view)="onViewDocument($event)"
                    [buttonDisabled]="(documentsMap['MALPRACTICE'] && documentsMap['MALPRACTICE'].length ? true : false) || impersonatedUser"
                    [placeholder]="'Enter policy number & upload'"
                    [ngClass] ="policyHolderCtrl.errors ? 'showAsterisk' : 'hideAsterisk'"
                    toolTip="Upload Document" deleteToolTip="Delete Document">
                </app-file-text-upload>
            </div>
        </div>

        <div class="form-grid">
            <div class="form-group">
                <app-text-input label="Limit per claim" [hideLabel]="false" [control]="limitPerClaimCtrl"
                    (keydown)="restrictNonNumeric($event, 'malpracticeLimitPerClaim')" [errorMessages]="VALIDATION_MESSAGES['malpracticeLimitPerClaim']"
                    [maxValue]="FIELD_LIMITS['malpracticeLimitPerClaim']['maxValue']"
                    [ngClass] ="limitPerClaimCtrl.errors ? 'showAsterisk' : 'hideAsterisk'">
                </app-text-input>
            </div>

            <div class="form-group">
                <app-date-input label=" Malpractice expiration date" [placeholder]="'MM/DD/YYYY'" acceptedFormats="MM/DD/YYYY"
                    [control]="expirationDateCtrl" [maxDate]="maxExpirationDate" [minDate]="minExpirationDate"
                    [ngClass] ="expirationDateCtrl.errors ? 'showAsterisk' : 'hideAsterisk'"
                    [errorMessages]="VALIDATION_MESSAGES['malpracticeExpirationDate']"></app-date-input>
            </div>

            <div class="form-group">
                <app-text-input label="Limit aggregate" [hideLabel]="false" [control]="limitAggregateCtrl"
                [ngClass] ="limitAggregateCtrl.errors ? 'showAsterisk' : 'hideAsterisk'"
                    (keydown)="restrictNonNumeric($event, 'malpracticeLimitAggregate')" [errorMessages]="VALIDATION_MESSAGES['malpracticeLimitAggregate']"
                    [maxValue]="FIELD_LIMITS['malpracticeLimitAggregate']['maxValue']">
                </app-text-input>
            </div>

        </div>

        <div [ngClass]="{
            'custom-input-grid': documentsMap['SPECIALTY'].length,
            'form-grid no-file': !documentsMap['SPECIALTY'].length
        }">
            <!-- ================= OPTIONAL LICENSES ================= -->
            <div class="form-group">
                <app-file-text-upload
                    [label]="isSpecialityLicenceNumberRequired ? 'Specialty license' : 'Specialty license (Optional)'"
                    [required]="isSpecialityLicenceNumberRequired" [hideLabel]="false" [control]="specialityLicenseCtrl"
                    [documents]="documentsMap['SPECIALTY']" docType="SPECIALTY" (upload)="onUploadDocument($event)"
                    (delete)="onDeleteDocument($event.type, $event.index)" (view)="onViewDocument($event)"
                    [ngClass] ="specialityLicenseCtrl.errors ? 'showAsterisk' : 'hideAsterisk'"
                    [errorMessages]="VALIDATION_MESSAGES['specialtyLicenseNumber']"
                    [buttonDisabled]="(documentsMap['SPECIALTY'] && documentsMap['SPECIALTY'].length ? true : false) || impersonatedUser"
                    [placeholder]="'Enter number & upload'" [maxLength]="FIELD_LIMITS['specialtyLicenseNumber']['maxLength']" toolTip="Upload Document" deleteToolTip="Delete Document">
                </app-file-text-upload>
            </div>
            @if(specialityLicenseCtrl.value) {
            <div class="form-group">
                <app-date-input label="Effective date" [placeholder]="'MM/DD/YYYY'" acceptedFormats="MM/DD/YYYY"
                    [control]="specialtyLicenseEffectiveDateCtrl" [maxDate]="maxExpirationDate" 
                    [ngClass] ="specialtyLicenseEffectiveDateCtrl.errors ? 'showAsterisk' : 'hideAsterisk'"
                    [errorMessages]="VALIDATION_MESSAGES['specialtyLicenseEffectiveDate']"></app-date-input>
            </div>
            }
        </div>

        <div [ngClass]="{
            'custom-input-grid': documentsMap['ANESTHESIA'].length,
            'form-grid no-file': !documentsMap['ANESTHESIA'].length
        }">
            <div class="form-group dentistClass">
                <app-file-text-upload label="Anesthesia or IV sedation (Optional)" [required]="false"
                    [hideLabel]="false" [control]="anesthesiaCtrl" [documents]="documentsMap['ANESTHESIA']"
                    docType="ANESTHESIA" (upload)="onUploadDocument($event)"
                    (delete)="onDeleteDocument($event.type, $event.index)" (view)="onViewDocument($event)"
                    [errorMessages]="VALIDATION_MESSAGES['anesthesiaSedationLicense']"
                    [buttonDisabled]="(documentsMap['ANESTHESIA'] && documentsMap['ANESTHESIA'].length ? true : false) || impersonatedUser"
                    [placeholder]="'Enter number & upload'" [maxLength]="FIELD_LIMITS['anesthesiaSedationLicense']['maxLength']" toolTip="Upload Document" deleteToolTip="Delete Document">
                </app-file-text-upload>
            </div>
            @if(anesthesiaCtrl.value) {
            <div class="form-group">
                <app-date-input label="Effective date" [placeholder]="'MM/DD/YYYY'" acceptedFormats="MM/DD/YYYY"
                    [control]="anesthesiaEffectiveDateCtrl" [maxDate]="maxExpirationDate" 
                    [ngClass] ="anesthesiaEffectiveDateCtrl.errors ? 'showAsterisk' : 'hideAsterisk'"
                    [errorMessages]="VALIDATION_MESSAGES['anesthesiaEffectiveDate']"></app-date-input>
            </div>
            }
        </div>
        <div class="form-grid-add-on-docs">
            <div class="additional-documents-title">
                Upload additional documents (optional)
            </div>
            <div class="form-inner-grid-add-on-docs">

                <div class="doc-inner-box">
                    <div class="doc-img-text">
                        <img src="assets/icons/doc-file.svg" alt="Doc File" class="iconwidth1">
                        <div class="add-on-doc-file-name">
                            @if(this.documentsMap['ADDITIONAL1'].length){
                            <span (click)="onViewDocument(this.documentsMap['ADDITIONAL1'][0])"
                                class="add-on-doc-present">
                                {{this.documentsMap['ADDITIONAL1'][0]['name']}}</span>
                            }
                            @else {
                            <span>attach document</span>
                            }
                        </div>
                    </div>
                    <div class="icon-delete-download">
                        @if(this.documentsMap['ADDITIONAL1'].length){
                        <img src="assets/icons/downl.svg" alt="Download File" class="iconwidth1"
                            (click)="onViewDocument(this.documentsMap['ADDITIONAL1'][0])">
                        @if(!impersonatedUser){<img src="assets/icons/delete1.svg" alt="Delete File" class="iconwidth1"
                            (click)="onDeleteDocument('ADDITIONAL1', 0)">}
                        }
                        @else {
                        <div>
                            <button type="button" class="upload-btn" title="Upload" (click)="fileInput1.click()" [disabled]="impersonatedUser">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                    <polyline points="17 8 12 3 7 8"></polyline>
                                    <line x1="12" y1="3" x2="12" y2="15"></line>
                                </svg>
                            </button>

                            <input #fileInput1 type="file" hidden [accept]="'application/pdf'"
                                (change)="onFileSelected($event, 'ADDITIONAL1')" />
                        </div>
                        }
                    </div>
                </div>
                <div class="doc-inner-box">
                    <div class="doc-img-text">
                        <img src="assets/icons/doc-file.svg" alt="Doc File" class="iconwidth1">
                        <div class="add-on-doc-file-name">
                            @if(this.documentsMap['ADDITIONAL2'].length){
                            <span (click)="onViewDocument(this.documentsMap['ADDITIONAL2'][0])"
                                class="add-on-doc-present">
                                {{this.documentsMap['ADDITIONAL2'][0]['name']}}</span>
                            }
                            @else {
                            <span>attach document</span>
                            }
                        </div>
                    </div>
                    <div class="icon-delete-download">
                        @if(this.documentsMap['ADDITIONAL2'].length){
                        <img src="assets/icons/downl.svg" alt="Download File" class="iconwidth1"
                            (click)="onViewDocument(this.documentsMap['ADDITIONAL2'][0])">
                            @if(!impersonatedUser){<img src="assets/icons/delete1.svg" alt="Delete File" class="iconwidth1"
                            (click)="onDeleteDocument('ADDITIONAL2', 0)">}
                        }
                        @else {
                        <div>
                            <button type="button" class="upload-btn" title="Upload" (click)="fileInput2.click()" [disabled]="impersonatedUser">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                    <polyline points="17 8 12 3 7 8"></polyline>
                                    <line x1="12" y1="3" x2="12" y2="15"></line>
                                </svg>
                            </button>

                            <input #fileInput2 type="file" hidden [accept]="'application/pdf'"
                                (change)="onFileSelected($event, 'ADDITIONAL2')" />
                        </div>
                        }
                    </div>
                </div>
                <div class="doc-inner-box">
                    <div class="doc-img-text">
                        <img src="assets/icons/doc-file.svg" alt="Doc File" class="iconwidth1">
                        <div class="add-on-doc-file-name">
                            @if(this.documentsMap['ADDITIONAL3'].length){
                            <span (click)="onViewDocument(this.documentsMap['ADDITIONAL3'][0])"
                                class="add-on-doc-present">
                                {{this.documentsMap['ADDITIONAL3'][0]['name']}}</span>
                            }
                            @else {
                            <span>attach document</span>
                            }
                        </div>
                    </div>
                    <div class="icon-delete-download">
                        @if(this.documentsMap['ADDITIONAL3'].length){
                        <img src="assets/icons/downl.svg" alt="Download File" class="iconwidth1"
                            (click)="onViewDocument(this.documentsMap['ADDITIONAL3'][0])">
                            @if(!impersonatedUser){<img src="assets/icons/delete1.svg" alt="Delete File" class="iconwidth1"
                            (click)="onDeleteDocument('ADDITIONAL3', 0)">}
                        }
                        @else {
                        <div>
                            <button type="button" class="upload-btn" title="Upload" (click)="fileInput3.click()" [disabled]="impersonatedUser">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                    <polyline points="17 8 12 3 7 8"></polyline>
                                    <line x1="12" y1="3" x2="12" y2="15"></line>
                                </svg>
                            </button>

                            <input #fileInput3 type="file" hidden [accept]="'application/pdf'"
                                (change)="onFileSelected($event, 'ADDITIONAL3')" />
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>

    </form>

    <!-- ================= NAVIGATION ================= -->
    <app-wizard-navigation [showBack]="true" [showNext]="true" (back)="onBack()" (cancel)="onCancel()"
        (next)="onNext()"></app-wizard-navigation>
</div>

